import React, { Component } from 'react';
import { Building2, Home, Construction, Sparkles, Factory, Package, CheckCircle, TrendingUp, Truck, Calendar, Users, Star, Shield, Award, Zap, Globe, Layers, Settings, Heart, Target, Wrench, Hammer, Warehouse, PaintBucket, Brush, HardHat, ArrowRight, Phone, Mail, MapPin, Clock, Leaf, BarChart2 } from 'lucide-react';
export const ICON_MAP: Record<string, ComponentType<{
  className?: string;
}>> = {
  Building2,
  Home,
  Construction,
  Sparkles,
  Factory,
  Package,
  CheckCircle,
  TrendingUp,
  Truck,
  Calendar,
  Users,
  Star,
  Shield,
  Award,
  Zap,
  Globe,
  Layers,
  Settings,
  Heart,
  Target,
  Wrench,
  Hammer,
  Warehouse,
  PaintBucket,
  Brush,
  HardHat,
  ArrowRight,
  Phone,
  Mail,
  MapPin,
  Clock,
  Leaf,
  BarChart2
};
export const ICON_NAMES = Object.keys(ICON_MAP);
export function renderIcon(name: string, className = 'h-6 w-6'): React.ReactNode {
  const Icon = ICON_MAP[name] || Package;
  return <Icon className={className} data-id="element-1203" />;
}